/* THEORIC - Comunidade (formulario + pop-up)
   - Formularios [data-tcm-form]: envio sem recarregar para /contact (form 'customer').
     Falhas de validacao permanecem no formulario, sem redirecionar para /challenge.
   - Pop-up [data-tcm-popup]: aparece por tempo, rolagem ou intencao de saida,
     uma vez a cada N dias, nunca sobre outro pop-up/gaveta aberto.
   - Eventos para GA4/Clarity via dataLayer: tcm_popup_view, tcm_popup_close, tcm_submit. */
(function () {
  if (window.__theoricComunidade) return;
  window.__theoricComunidade = true;

  var STORE_KEY = 'theoric_comunidade';
  var POPUP_REVISION = 'form-simples-2026-09';
  var SESSION_SEEN_KEY = 'tcm_seen_' + POPUP_REVISION;

  function store(get, val) {
    try {
      var data = JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {};
      if (get) return data[get];
      Object.assign(data, val);
      localStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (e) { return undefined; }
  }

  function track(event, extra) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, extra || {}));
      if (window.clarity) window.clarity('event', event);
    } catch (e) {}
  }

  /* ---------------- Formulario ---------------- */
  function maskPhone(v) {
    var d = v.replace(/\D/g, '').slice(0, 11);
    if (d.length <= 2) return d.length ? '(' + d : '';
    if (d.length <= 6) return '(' + d.slice(0, 2) + ') ' + d.slice(2);
    if (d.length <= 10) return '(' + d.slice(0, 2) + ') ' + d.slice(2, 6) + '-' + d.slice(6);
    return '(' + d.slice(0, 2) + ') ' + d.slice(2, 7) + '-' + d.slice(7);
  }

  function showSuccess(wrap, address) {
    var fields = wrap.querySelector('[data-tcm-fields]');
    var ok = wrap.querySelector('[data-tcm-success]');
    if (address) wrap.querySelectorAll('[data-tcm-success-email]').forEach(function (b) { b.textContent = address; });
    if (fields) fields.hidden = true;
    if (ok) { ok.hidden = false; ok.focus({ preventScroll: true }); }
    wrap.classList.add('is-done');
    goToGroup(wrap);
  }

  // Envio nativo (hCaptcha da Shopify): a pagina vai recarregar. Antes disso a
  // pessoa ve por HOLD ms que o e-mail foi recebido; a confirmacao de verdade
  // aparece depois da recarga (ver "voltou" no pop-up).
  var HOLD = 2500;
  var EMAIL_KEY = 'tcm_pending_email';
  function showSending(wrap) {
    if (!wrap || wrap.querySelector('[data-tcm-sending]')) return false;
    var fields = wrap.querySelector('[data-tcm-fields]');
    if (!fields) return false;
    var box = document.createElement('div');
    box.className = 'tcm-form__sending';
    box.setAttribute('data-tcm-sending', '');
    box.setAttribute('role', 'status');
    box.tabIndex = -1;
    box.innerHTML = '<span class="tcm-form__sending-dot" aria-hidden="true"></span>' +
      '<p class="tcm-form__success-title">Recebemos seu e-mail.</p>' +
      '<p class="tcm-form__success-text">Só um instante: estamos confirmando sua inscrição.</p>';
    fields.hidden = true;
    fields.parentNode.insertBefore(box, fields);
    var pop = wrap.closest('[data-tcm-popup]');
    if (pop) pop.classList.add('is-sending');
    box.focus({ preventScroll: true });
    return true;
  }

  // Grupo da Comunidade no WhatsApp: abre numa ABA NOVA, a loja continua aberta.
  // O navegador so deixa abrir aba nova no proprio clique, entao a aba e aberta
  // no envio (depois de validar o e-mail) e o cadastro segue nesta aba.
  function openGroupTab(wrap) {
    var url = wrap && wrap.getAttribute('data-tcm-group-url');
    if (!url || wrap.dataset.tcmGroupOpen) return;
    var w = null;
    try { w = window.open(url, '_blank'); } catch (e) {}
    if (w) {
      try { w.opener = null; } catch (e) {}
      wrap.dataset.tcmGroupOpen = '1';
      track('tcm_grupo', { tcm_modo: 'nova_aba' });
    }
  }

  // Mensagem do sucesso: confirma a aba aberta ou oferece o botao (aba nova).
  function goToGroup(wrap) {
    var url = wrap.getAttribute('data-tcm-group-url');
    if (!url || wrap.dataset.tcmGroupReady) return;
    wrap.dataset.tcmGroupReady = '1';
    var msg = wrap.querySelector('[data-tcm-group-msg]');
    if (msg) {
      msg.textContent = wrap.dataset.tcmGroupOpen
        ? 'Abrimos o grupo da Comunidade no WhatsApp numa nova aba.'
        : 'Agora entre no grupo da Comunidade no WhatsApp.';
    }
    var link = wrap.querySelector('[data-tcm-group]');
    if (link) link.addEventListener('click', function () { track('tcm_grupo', { tcm_modo: 'botao' }); });
  }

  function initForm(form) {
    if (form.dataset.tcmReady) return;
    form.dataset.tcmReady = '1';
    var wrap = form.closest('[data-tcm-form-wrap]');
    var email = form.querySelector('input[type="email"]');
    var error = form.querySelector('[data-tcm-error]');
    var submit = form.querySelector('[data-tcm-submit]');
    var tags = form.querySelector('[data-tcm-tags]');
    var wa = form.querySelector('[data-tcm-wa]');
    var phone = form.querySelector('[data-tcm-phone]');
    var origem = form.getAttribute('data-tcm-form');

    // Envio nativo (sem JS ou depois do hCaptcha): a pagina volta com
    // ?customer_posted=true e o sucesso ja renderizado. Marca o cadastro e segue
    // para o grupo.
    if (wrap && !form.querySelector('[data-tcm-fields]') && form.querySelector('[data-tcm-success]') && /customer_posted=true/.test(location.search)) {
      store(null, { joined: Date.now() });
      goToGroup(wrap);
    }

    if (phone) phone.addEventListener('input', function () { phone.value = maskPhone(phone.value); });
    if (email) email.addEventListener('input', function () { email.removeAttribute('aria-invalid'); if (error) error.textContent = ''; });

    form.addEventListener('submit', function (e) {
      // Segunda tentativa, depois de a Shopify pedir o hCaptcha: deixa o envio nativo
      // seguir (o script de captcha da Shopify preenche h-captcha-response).
      if (form.dataset.native === '1') return;
      e.preventDefault();
      if (!email || !email.value || !email.checkValidity()) {
        email.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = 'Digite um e-mail válido, como nome@email.com.';
        email.focus();
        return;
      }
      if (tags) {
        var t = tags.getAttribute('data-base');
        if (wa && wa.checked && phone && phone.value.replace(/\D/g, '').length >= 10) t += ',whatsapp-optin';
        tags.value = t;
      }
      if (wa && wa.checked && phone && phone.value.replace(/\D/g, '').length < 10) {
        phone.setAttribute('aria-invalid', 'true');
        if (error) error.textContent = 'Para receber pelo WhatsApp, informe o número com DDD.';
        phone.focus();
        return;
      }

      openGroupTab(wrap);
      submit.disabled = true;
      submit.classList.add('is-loading');
      if (error) error.textContent = '';

      // Qualquer resposta que nao seja o sucesso confirmado (hCaptcha, erro, rede)
      // segue pelo envio nativo da Shopify, sem mostrar erro antes.
      function nativo() {
        store(null, { pending: origem });
        try { sessionStorage.setItem(EMAIL_KEY, email.value.trim()); } catch (e) {}
        form.dataset.native = '1';
        var go = function () {
          if (form.requestSubmit) form.requestSubmit();
          else form.submit();
        };
        if (showSending(wrap)) setTimeout(go, HOLD);
        else go();
      }

      fetch(form.getAttribute('action') || '/contact', {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
        credentials: 'same-origin'
      }).then(function (res) {
        var url = res.url || '';
        // A Shopify redireciona para ?customer_posted=true quando o cadastro da certo.
        if (res.ok && url.indexOf('customer_posted=true') !== -1) {
          store(null, { joined: Date.now() });
          track('tcm_submit', { tcm_origem: origem, tcm_whatsapp: !!(wa && wa.checked) });
          showSuccess(wrap, email.value.trim());
          document.dispatchEvent(new CustomEvent('theoric:comunidade:joined', { detail: { origem: origem } }));
          return null;
        }
        // O envio em segundo plano nao leva o token do hCaptcha: quando a Shopify
        // pede a verificacao (/challenge) ou algo falha, o envio nativo resolve e
        // volta com ?customer_posted=true, onde o sucesso ja aparece.
        nativo();
        return null;
      }).catch(function () {
        nativo();
      }).finally(function () {
        submit.disabled = false;
        submit.classList.remove('is-loading');
      });
    });

    var copy = form.querySelector('[data-tcm-copy]');
    if (copy) copy.addEventListener('click', function () {
      var code = copy.getAttribute('data-tcm-copy');
      (navigator.clipboard ? navigator.clipboard.writeText(code) : Promise.reject()).then(function () {
        copy.textContent = 'Copiado';
      }).catch(function () { copy.textContent = code; });
    });
  }

  function initForms(root) {
    (root || document).querySelectorAll('form[data-tcm-form]').forEach(initForm);
  }

  /* ---------------- Pop-up ---------------- */
  // Visivel de verdade: com tamanho, sem display:none/visibility:hidden e sem
  // opacidade zero nele ou nos pais (a busca do tema fica montada com opacity 0).
  function isShown(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 2 || r.height < 2) return false;
    if (el.checkVisibility) {
      return el.checkVisibility({ opacityProperty: true, visibilityProperty: true, contentVisibilityAuto: true });
    }
    for (var n = el; n && n.nodeType === 1; n = n.parentElement) {
      var cs = getComputedStyle(n);
      if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.05) return false;
    }
    return true;
  }

  function otherModalOpen(extraSelectors) {
    var quiz = document.getElementById('meuQuizPopup');
    if (quiz && quiz.style.display && quiz.style.display !== 'none' && isShown(quiz)) return true;
    var fixed = document.querySelectorAll('.login-popup-overlay.active, cart-theoric.active, cart-drawer.active, details[open] > .menu-drawer');
    for (var f = 0; f < fixed.length; f++) if (isShown(fixed[f])) return true;
    if (extraSelectors) {
      try {
        var nodes = document.querySelectorAll(extraSelectors);
        for (var i = 0; i < nodes.length; i++) if (isShown(nodes[i])) return true;
      } catch (e) {}
    }
    var dialogs = document.querySelectorAll('[aria-modal="true"]');
    for (var j = 0; j < dialogs.length; j++) {
      if (dialogs[j].closest('[data-tcm-popup]')) continue;
      if (isShown(dialogs[j])) return true;
    }
    return false;
  }

  function initPopup(pop) {
    if (!pop || pop.dataset.tcmReady) return;
    pop.dataset.tcmReady = '1';
    var cfg = {
      delay: parseInt(pop.getAttribute('data-delay'), 10) || 15,
      scroll: parseInt(pop.getAttribute('data-scroll'), 10) || 50,
      exit: pop.getAttribute('data-exit') === 'true',
      days: parseInt(pop.getAttribute('data-days'), 10) || 14,
      mobile: pop.getAttribute('data-mobile') !== 'false',
      extra: pop.getAttribute('data-extra-selectors') || '',
      design: pop.hasAttribute('data-design-mode')
    };
    var dialog = pop.querySelector('[data-tcm-dialog]');
    var lastFocus = null;
    var opened = false;
    var timer, retry;

    function eligible() {
      if (cfg.design) return false;
      if (!cfg.mobile && window.matchMedia('(max-width: 749px)').matches) return false;
      if (store('joined')) return false;
      var dismissed = store('dismissed');
      if (store('dismissed_revision') === POPUP_REVISION && dismissed && Date.now() - dismissed < cfg.days * 864e5) return false;
      try { if (sessionStorage.getItem(SESSION_SEEN_KEY)) return false; } catch (e) {}
      return true;
    }

    function focusables() {
      return Array.prototype.filter.call(
        dialog.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), [tabindex]:not([tabindex="-1"])'),
        function (el) { return el.offsetParent !== null || el === document.activeElement; }
      );
    }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close('esc'); return; }
      if (e.key !== 'Tab') return;
      var f = focusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    function open(reason, force) {
      if (opened) return;
      if (!force && !eligible()) return;
      if (!force && otherModalOpen(cfg.extra)) {
        clearTimeout(retry);
        retry = setTimeout(function () { open(reason); }, 8000);
        return;
      }
      opened = true;
      lastFocus = document.activeElement;
      pop.hidden = false;
      document.documentElement.classList.add('tcm-lock');
      void pop.offsetWidth; // forca o layout para a transicao sem depender de requestAnimationFrame
      pop.classList.add('is-open');
      var target = dialog.querySelector('input[type="email"]') || dialog;
      setTimeout(function () { (window.matchMedia('(max-width: 749px)').matches ? dialog : target).focus({ preventScroll: true }); }, 60);
      document.addEventListener('keydown', onKey);
      try { sessionStorage.setItem(SESSION_SEEN_KEY, '1'); } catch (e) {}
      track('tcm_popup_view', { tcm_gatilho: reason });
    }

    function close(reason) {
      if (!opened) return;
      opened = false;
      pop.classList.remove('is-open');
      document.documentElement.classList.remove('tcm-lock');
      document.removeEventListener('keydown', onKey);
      if (!store('joined')) store(null, { dismissed: Date.now(), dismissed_revision: POPUP_REVISION });
      track('tcm_popup_close', { tcm_motivo: reason || 'fechar' });
      setTimeout(function () {
        pop.hidden = true;
        var usable = lastFocus && lastFocus !== document.body && document.contains(lastFocus) && lastFocus.offsetParent !== null;
        var back = usable ? lastFocus : null;
        if (back && back.focus) back.focus({ preventScroll: true });
        else if (dialog.contains(document.activeElement)) document.activeElement.blur();
      }, 260);
    }

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-tcm-close]')) close('fechar');
      else if (e.target === pop || e.target.hasAttribute('data-tcm-backdrop')) close('fora');
    });
    document.addEventListener('theoric:comunidade:joined', function () {
      if (!opened) return;
      pop.classList.add('is-joined');
      setTimeout(function () { close('cadastro'); }, 8000);
    });

    if (cfg.design) {
      setTimeout(function () { open('editor', true); }, 500);
      return;
    }

    // Voltou do envio nativo com o cadastro feito pelo pop-up: reabre ja na
    // confirmacao, com o e-mail digitado, e fecha sozinho como no envio sem recarga.
    var voltou = /customer_posted=true/.test(location.search) && store('pending') === 'popup' &&
      !pop.querySelector('[data-tcm-fields]') && pop.querySelector('[data-tcm-success]');
    if (voltou) {
      store(null, { pending: null });
      var address = '';
      try { address = sessionStorage.getItem(EMAIL_KEY) || ''; sessionStorage.removeItem(EMAIL_KEY); } catch (e) {}
      if (address) pop.querySelectorAll('[data-tcm-success-email]').forEach(function (b) { b.textContent = address; });
      pop.classList.add('is-joined');
      open('cadastro', true);
      track('tcm_submit', { tcm_origem: 'popup', tcm_modo: 'nativo' });
      setTimeout(function () { close('cadastro'); }, 8000);
      return;
    }
    if (!eligible()) return;

    // Gatilhos: tempo, rolagem ou intencao de saida (desktop), o que vier primeiro.
    // Nunca abre no meio de uma rolagem: o pop-up trava a pagina (tcm-lock) e,
    // aberto durante o gesto, parecia que o scroll tinha travado. Espera a pessoa
    // parar de rolar por IDLE ms.
    var IDLE = 900;
    var lastScroll = 0;
    function openWhenIdle(reason) {
      var wait = IDLE - (Date.now() - lastScroll);
      if (wait > 0) { setTimeout(function () { openWhenIdle(reason); }, wait); return; }
      open(reason);
    }
    timer = setTimeout(function () { openWhenIdle('tempo'); }, cfg.delay * 1000);
    var scrollHit = false;
    function onScroll() {
      lastScroll = Date.now();
      if (scrollHit) return;
      var h = document.documentElement.scrollHeight - innerHeight;
      if (h > 0 && (scrollY / h) * 100 >= cfg.scroll) {
        scrollHit = true;
        openWhenIdle('rolagem');
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (cfg.exit && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      document.addEventListener('mouseout', function (e) {
        if (!e.relatedTarget && e.clientY <= 0) open('saida');
      });
    }

    // Editor do tema: selecionar a secao abre o pop-up para edicao.
    document.addEventListener('shopify:section:select', function (e) {
      if (e.target.contains(pop)) { pop.dataset.forced = '1'; open('editor', true); }
    });
    document.addEventListener('shopify:section:deselect', function (e) {
      if (e.target.contains(pop)) close('editor');
    });
  }

  function boot() {
    initForms(document);
    document.querySelectorAll('[data-tcm-popup]').forEach(initPopup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) {
    initForms(e.target);
    e.target.querySelectorAll('[data-tcm-popup]').forEach(initPopup);
  });
})();
